module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "catalogs",
    class: {
      visible: showCatalog
    },
    on: {
      "touchstart": handleStart,
      "touchend": handleEnd
    }
  }, [_h('div', {
    staticClass: "menu-contents"
  }, [_m(0), " ", _m(1), " ", _m(2), " ", _h('ul', {
    staticClass: "catalog"
  }, [_l((dishsData), function(catalog, index) {
    return _h('li', {
      class: {
        active: index == activeCatalog
      },
      on: {
        "click": function($event) {
          updateCatalog(index)
        }
      }
    }, [_h('span', [_s(catalog.catalog)]), " ", _h('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (catalog.orderedDishs.length),
        expression: "catalog.orderedDishs.length"
      }],
      staticClass: "num"
    }, [_s(catalog.orderedDishs.length)])])
  })])])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "avatar"
  }, [_h('img', {
    attrs: {
      "src": require("../img/avatar.jpg")
    }
  })])
}},function (){with(this) {
  return _h('div', {
    staticClass: "my-center"
  }, [_h('a', ["个人中心"])])
}},function (){with(this) {
  return _h('div', {
    staticClass: "tip"
  }, [_h('span', ["本店菜单"])])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-7cdcb0da!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuContents.vue
 ** module id = 77
 ** module chunks = 1
 **/